import { KeyRoundIcon, TriangleAlertIcon } from "lucide-react";

import { Column, Row, Text } from "@/components";
import { Button } from "@/components/ui/button";

import { searchStore } from "@/stores/search";

// Blocks the results until the staffer either adds keywords or explicitly
// chooses to search on semantics alone — an unkeyworded search is almost
// always an oversight and the results are noticeably worse.
export const SearchV2NoKeywordsGate = ({
  onAcknowledge,
}: {
  onAcknowledge: () => void;
}) => {
  /* React Hooks */
  const { requestFiltersDialog } = searchStore();

  /* Render */
  return (
    <Column className="items-center gap-5 rounded-lg px-6 py-12">
      <TriangleAlertIcon className="h-7 w-7 text-amber-600" />
      <Column className="items-center gap-1 text-center">
        <Text className="text-base font-semibold text-slate-800">
          No keywords are set
        </Text>
        <Text className="max-w-md text-sm font-normal text-slate-600">
          Without keywords this search matches on semantics only, which is not
          ideal. Add a few keywords first or continue without them.
        </Text>
      </Column>
      <Row className="gap-3">
        <Button className="h-9 px-4" onClick={onAcknowledge} variant="outline">
          Search without keywords
        </Button>
        <Button className="h-9 gap-2 px-4" onClick={requestFiltersDialog}>
          <KeyRoundIcon className="h-4 w-4" />
          Add keywords
        </Button>
      </Row>
    </Column>
  );
};
